// extracted by mini-css-extract-plugin
export var text = "_55-0";